import { configureStore } from '@reduxjs/toolkit';
import userSessionReducer from './UserSession';

import adminClientList from './Admin/ClientList';
import adminOrderList from './Admin/OrderList';
import adminOrderDisplay from './Admin/OrderDisplay';
import adminAnalyzer from './Admin/Analyser';
import adminWritersList from './Admin/WritersList';
import adminWriterDisplay from './Admin/WriterDisplay';
import adminUserManagement from './Admin/UserManagement';
import adminWebsiteDetails from './Admin/WebsiteDisplay';

import writerOrderList from './Writer/OrderList';
import writerProjectList from './Writer/ProjectList';
import writerOrderDisplayByClient from './Writer/OrderDisplayByClient';
import writerOrderDisplay from './Writer/OrderDisplay';
import writerAnalyzer from './Writer/Analyser';
import writerRedactionData from './Writer/RedactionData';

import clientOrderList from './Client/ClientOrderList';
import clientWebsiteDetails from './Client/ClientWebsiteDisplay';
import clientOrderDisplay from './Client/OrderDisplay';
import clientAnalyzer from './Client/ClientAnalyser';

import clientNotification from './Client/ClientNotification';
import consultantWebsiteList from './Consultant/WebsiteList';
import consultantOrderList from './Consultant/OrderList';
import billsDisplay from './Writer/BillDisplay/reducers';
import allBills from './Admin/BillDisplay/reducers';

import languageStore from './Languages';

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import persistStore from 'redux-persist/es/persistStore';
import adminClientClientList from './AdminClient/ClientList';
import adminClientOrderList from './AdminClient/OrderList';
import adminClientUserManagement from './AdminClient/CLientAdminManagement';
import adminCLientOrderDisplay from './AdminClient/OrderDisplay';
import adminClientWebsiteDetails from './AdminClient/WebsiteDisplay';
import adminClientRedactionData from './AdminClient/RedactionData';
import smartTextFormReducer from './AdminClient/SmartTextForm';
import aiSmartContentTypeReducer from './AdminClient/AISmartContentType';
import projectManagerUserManagement from './ProjectManager/ProjectManagerManagement';


const store = configureStore({
  reducer: {
    userSession: persistReducer(
      {
        key: 'userSessionReducer',
        storage,
      },
      userSessionReducer
    ),

    //Admin
    adminClientList: adminClientList,
    adminOrderList: adminOrderList,
    adminOrderDisplay: adminOrderDisplay,
    adminAnalyzer: adminAnalyzer,
    adminWritersList: adminWritersList,
    adminWriterDisplay: adminWriterDisplay,
    adminUserManagement: adminUserManagement,
    adminWebsiteDetails: adminWebsiteDetails,

    //Writer
    writerOrderList: writerOrderList,
    writerProjectList: writerProjectList,
    writerOrderDisplayByClient: writerOrderDisplayByClient,
    writerOrderDisplay: writerOrderDisplay,
    writerAnalyzer: writerAnalyzer,
    writerRedactionData: writerRedactionData,
    billsDisplay: billsDisplay,
    allBills: allBills,

    //Client
    clientOrderList: clientOrderList,
    clientWebsiteDetails: clientWebsiteDetails,
    clientOrderDisplay: clientOrderDisplay,
    clientAnalyzer: clientAnalyzer,
    clientNotification: clientNotification,

    //Consultant
    consultantWebsiteList: consultantWebsiteList,
    consultantOrderList: consultantOrderList,

    //AdminClient
    adminClientClientList: adminClientClientList,
    adminClientOrderList: adminClientOrderList,
    adminClientWebsiteDetails: adminClientWebsiteDetails,
    languageStore: languageStore,
    adminClientUserManagement: adminClientUserManagement,
    adminCLientOrderDisplay: adminCLientOrderDisplay,
    adminClientRedactionData: persistReducer(
      {
        key: 'adminClientRedactionData',
        storage,
      },
      adminClientRedactionData
    ),
    smartTextForm: persistReducer(
      {
        key: 'smartTextForm',
        storage,
      },
      smartTextFormReducer
    ),
    adminClientAISmartContentType: aiSmartContentTypeReducer,

    //ProjectManager
    projectManagerUserManagement: projectManagerUserManagement,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };
